export const LOADING = 'marketplace/LOADING';
export const GET = 'marketplace/GET';
export const SET_PRODUCTS = 'marketplace/SET_PRODUCTS';

export const REMOVE_PRODUCT = 'marketplace/REMOVE_PRODUCT';